<template>
    <div class="activeInfo">
        <div class="content">
            <p class="title">活动标题</p>
            <div class="activeImg">
                <img :src="dataList.targetName" alt="">
            </div>
            <div class="item">
                <p class="itemTile">活动规则</p>
                <div class="itemContent">
                    <p>活动结束时间:{{dataList.dataList}}</p>
                    <p>活动门店:</p>
                </div>
            </div>
            <div v-html="dataList.imageText"></div>
        </div>
    </div>
</template>
<script>
import lion from '@/assets/img/lion.jpg'
import contents from '@/components/content';
import { getActivityDetail } from '@/api/index';
export default {
    data(){
        return {
            lion,
            dataList:{}
        }
    },
    created(){
        this.getData();
    },
    methods:{
        getData(){
            getActivityDetail({activityId: this.$route.query.activeId}).then(res=>{
                res.data.targetName = `https://fanhuayiju.oss-cn-beijing.aliyuncs.com/${res.data.targetName .targetName}`;
                this.dataList = res.data;
            }).catch(error=>{

            })
        }
    }
}
</script>
<style lang="scss" scoped>
.activeInfo{
    background: #f6f6f6;
    min-height: 100%;
    .content{
        margin: 0 20px;
        .title{
            height: 81px;
            line-height: 81px;
        }
        .activeImg{
            width: 100%;
            height: 500px;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .item{
            background:#ffffff;
            padding-top:20px;
            margin-top: 20px;
            .itemTile{
                padding-bottom: 20px;
                margin-left:10px; 
                border-bottom:1px solid #f6f6f6; 
                font-size: 30px;
            }
            .itemContent{
                p{
                    margin-top:20px; 
                    margin-left:10px; 
                }
                padding-bottom:20px; 
            }
        }
    }
}

</style>

